import * as api from '@codegrade/api';
import { Just, Maybe, Nothing } from '@codegrade/maybe';
import * as utils from '@/utils';
import * as store from './store';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const getToken = (url) => {
    const res = store.UserStore.dangerousSession().chainNullable(({ token }) => {
        if (utils.urlSameOrigin(url)) {
            return token;
        }
        return null;
    });
    return res;
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Client extends api.CodeGradeApi {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    maybeApp = Nothing;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(override) {
        super({
            base: '',
            token: (_, request) => Promise.resolve(getToken(request.url)),
            processError: Maybe.of((request, err) => this.maybeApp.mapOrDefault(app => {
                if (!(err instanceof api.ApiResultError)) {
                    return err;
                }
                return app
                    .handleHttpError(err.error, err.response.status, request.method, request.path, request.headers?.get('Authorization'))
                    .mapOrDefault(msg => new Error(msg), err);
            }, err)),
            ...override,
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    onVueCreated(app) {
        this.maybeApp = new Just(app);
    }
    /* eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation. */
    maybeRequest(maybe, callback) {
        return maybe.caseOf({
            Just: val => callback(val),
            Nothing: utils.emptyResponse,
        });
    }
}
const client = new Client();
/** An Unauthorized Codegrade Client for the frontend. */
export const unauthorizedClient = new Client({ token: Maybe.empty() });
export default client;
